<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { ActivationGroup } from "@/types/calculators";
import { activationGroups } from "@/constants/activations";
import { useI18n } from "vue-i18n";

defineProps<{
  selectedActivation: ActivationGroup;
}>();
defineEmits<{
  (e: "changeActivationGroup", newActivationGroup: ActivationGroup): void;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="h-full w-[427px] bg-brown overflow-y-auto no-scrollbar hidden lg:block"
  >
    <div class="pt-8 pl-8 pb-[17px] border-b border-white border-opacity-20">
      <p class="font-semibold text-xl leading-[28px] text-muted text-left">
        {{ t("calculators.activations.another_activations") }}
      </p>
    </div>
    <div
      v-for="activationGroup in activationGroups"
      :key="activationGroup.key"
      class="py-4 pl-4 items-center border-b border-white border-opacity-20 hover:bg-white hover:bg-opacity-20 group hover:cursor-pointer"
      @click="$emit('changeActivationGroup', activationGroup)"
      :class="
        selectedActivation.key === activationGroup.key ? 'hidden' : 'flex'
      "
    >
      <img
        class="w-[130px] h-[67px] object-center object-cover rounded-lg"
        :src="
          require(`@/assets/calculators/activations/${activationGroup.key}.jpg`)
        "
        :alt="activationGroup.key"
      />
      <p
        class="font-medium text-base leading-[24px] text-white pl-4 group-hover:underline"
      >
        {{ t(`calculators.activations.group.${activationGroup.key}`) }}
      </p>
    </div>
  </div>
</template>
